// GRID ROW X COLUMN CODE
export const GRID_1X1 = 101001;
export const GRID_1X2 = 101002;
export const GRID_1X3 = 101003;
export const GRID_1X4 = 101004;
export const GRID_2X1 = 102001;
export const GRID_2X2 = 102002;
export const GRID_2X3 = 102003;
export const GRID_2X4 = 102004;
export const GRID_3X1 = 103001;
export const GRID_3X2 = 103002;
export const GRID_3X3 = 103003;
export const GRID_3X4 = 103004;
export const GRID_4X1 = 104001;
export const GRID_4X2 = 104002;
export const GRID_4X3 = 104003;
export const GRID_4X4 = 104004;

// BUTTON ROW X COLUMN CODE
export const BUTTON_1X1 = 201001;
export const BUTTON_1X2 = 201002;
export const BUTTON_1X3 = 201003;
export const BUTTON_1X4 = 201004;
export const BUTTON_2X1 = 202001;
export const BUTTON_2X2 = 202002;
export const BUTTON_2X3 = 202003;
export const BUTTON_2X4 = 202004;
export const BUTTON_3X1 = 203001;
export const BUTTON_3X2 = 203002;
export const BUTTON_3X3 = 203003;
export const BUTTON_3X4 = 203004;
export const BUTTON_4X1 = 204001;
export const BUTTON_4X2 = 204002;
export const BUTTON_4X3 = 204003;
export const BUTTON_4X4 = 204004;

// GRAPH CODE
export const GRAPH_1X1 = 101001;
export const GRAPH_1X2 = 101002;
export const GRAPH_1X3 = 101003;
export const GRAPH_1X4 = 101004;
export const GRAPH_2X1 = 102001;
export const GRAPH_2X2 = 102002;
export const GRAPH_2X3 = 102003;
export const GRAPH_2X4 = 102004;
export const GRAPH_3X1 = 103001;
export const GRAPH_3X2 = 103002;
export const GRAPH_3X3 = 103003;
export const GRAPH_3X4 = 103004;
export const GRAPH_4X1 = 104001;
export const GRAPH_4X2 = 104002;
export const GRAPH_4X3 = 104003;
export const GRAPH_4X4 = 104004;

// TYPE OF DASHBOARD TYPE

export const DASHBOARD_BASIC = "BASIC";
export const DASHBOARD_EMBEDDED = "EMBED";

// DASHBOARD CATEGORY
export const CAT_SINGLE = 'SINGLE';
export const CAT_THREE_PHASE = 'THREE';
export const CAT_LIST = 'LIST';
export const CAT_CHART = 'CHART';
export const CAT_CONTROL = 'CONTROL';
export const CAT_MAP = 'MAP';


export function getCategory(finalCat) {
  if (finalCat === TYPE_CARD_VALUE) {
    return TYPE_CARD_VALUE;
  } else if (
    finalCat === TYPE_GRAPH_LINE_SMART ||
    finalCat === TYPE_GRAPH_BAR_MONITORING ||
    finalCat === TYPE_GRAPH_LINE_MONITORING ||
    finalCat === TYPE_GRAPH_PIE_MONITORING ||
    finalCat === TYPE_GRAPH_AREA_MONITORING ||
    finalCat === TYPE_GRAPH_BAR ||
    finalCat === TYPE_GRAPH_LINE ||
    finalCat === TYPE_GRAPH_TEXT ||
    finalCat === TYPE_GRAPH_PIE ||
    finalCat === TYPE_GRAPH_AREA) {
    return CAT_CHART;
  } else if (
    finalCat === BUTTON_TAGS_CARD ||
    finalCat === INPUT_TOGGLE_TAGS_CARD ||
    finalCat === INPUT_TEXT_TAGS_CARD ||
    finalCat === INPUT_NUMBER_TAGS_CARD ||
    finalCat === BUTTON_CUSTOM_CARD ||
    finalCat === INPUT_TOGGLE_CUSTOM_CARD ||
    finalCat === INPUT_TEXT_CUSTOM_CARD ||
    finalCat === INPUT_NUMBER_CUSTOM_CARD) {
    return CAT_CONTROL;
  } else if (finalCat === TYPE_THREE_PHASE) {
    return TYPE_THREE_PHASE
  } else if (finalCat === TYPE_COORDINATE) {
    return TYPE_COORDINATE
  } else if (finalCat === TYPE_STRAIN) {
    return TYPE_STRAIN
  } else if (finalCat === TYPE_CRACK) {
    return TYPE_CRACK
  } else if (finalCat === TYPE_MAP) {
    return TYPE_MAP
  } else if (finalCat === TYPE_TITLE) {
    return TYPE_TITLE
  } else if (finalCat === TYPE_LIST ||
    finalCat === TYPE_LIST_CUSTOM ||
    finalCat === TYPE_LIST_TRANSACTION ||
    finalCat === TYPE_LIST_PAYMENT) {
    return CAT_LIST
  } else if (finalCat === TYPE_DROPDOWN_SELECTOR) {
    return TYPE_DROPDOWN_SELECTOR
  }
  return CAT_SINGLE;
}


// TYPE OF VALUE CODE
export const TYPE_EMBEDDED = "EMBEDDED_DASHBOARD";
export const TYPE_CARD_VALUE = "SINGLE_VALUE_CARD";
export const SINGLE_IMAGE_CARD = "SINGLE_IMAGE_CARD";
export const TYPE_DEGREE = "DEGREE";
export const TYPE_TEMPERATURE_CELCIUS = "TEMP_CELCIUS";
export const TYPE_TEMPERATURE_FAHRENHEIT = "TEMP_FAHRENHEIT";
export const TYPE_TEMPERATURE_KELVIN = "TEMP_KELVIN";
export const TYPE_VERSION = "VERSION";
export const TYPE_VOLT = "VOLT";
export const TYPE_AMPERE = "AMPERE";
export const TYPE_WATT = "WATT";
export const TYPE_OHM = "OHM";
export const TYPE_KWH = "KWH";
export const TYPE_KW = "KW";
export const TYPE_PRESSURE_WATER = "PRESSURE_WATER";
export const TYPE_PRESSURE_AIR = "PRESSURE_AIR";
export const TYPE_HUMIDITY = "HUMIDITY";
export const TYPE_CUSTOM = "CUSTOM";
export const TYPE_RUPIAH = "RUPIAH";
export const TYPE_LITER = "LITER";
export const TYPE_PERCENT = "PERCENTAGE";
export const TYPE_IMAGE = "IMAGE";

export const TYPE_THREE_PHASE = "THREE_PHASE_CARD";
export const TYPE_COORDINATE = "COORDINATE_CARD";
export const TYPE_STRAIN = "STRAIN_CARD";
export const TYPE_CRACK = "CRACK_CARD";
export const TYPE_LIST = "LIST_CARD";
export const TYPE_LIST_CUSTOM = "LIST_CUSTOM_CARD";
export const TYPE_LIST_TRANSACTION = "LIST_TRANSACTION_CARD";
export const TYPE_LIST_PAYMENT = "LIST_PAYMENT_CARD";

export const WEBSERVICE = "WEBSERVICE";
export const WEBSERVICE_FETCH = "WEBSERVICE_FETCH";
export const WEBSERVICE_STORAGE = "WEBSERVICE_STORAGE";

export const TYPE_MAP = "MAP_CARD";
export const TYPE_DROPDOWN_SELECTOR = "DROPDOWN_SELECTOR";

export const TYPE_GRAPH = "CHART_CARD";
export const TYPE_GRAPH_BAR = "BAR_CHART_CARD";
export const TYPE_GRAPH_BAR_MONITORING = "BAR_MONITORING_CHART_CARD";
export const TYPE_GRAPH_LINE = "LINE_CHART_CARD";
export const TYPE_GRAPH_TEXT = "TEXT_CHART_CARD"
export const TYPE_GRAPH_LINE_MONITORING = "LINE_MONITORING_CHART_CARD";
export const TYPE_GRAPH_LINE_SMART = "LINE_SMART_CHART_CARD";
export const TYPE_GRAPH_PIE = "PIE_CHART_CARD";
export const TYPE_GRAPH_PIE_MONITORING = "PIE_MONITORING_CHART_CARD";
export const TYPE_GRAPH_AREA = "AREA_CHART_CARD";
export const TYPE_GRAPH_AREA_MONITORING = "AREA_MONITORING_CHART_CARD";

export const TYPE_CARD_VALUE_DATA = "DATA_VALUE_CARD";

export const TYPE_TITLE = "TITLE";

export const TYPE_CARD_BUTTON = "BUTTON_CARD";
export const TYPE_BUTTON_SIMPLE = "BUTTON_CARD";
export const TYPE_BUTTON_INPUT_NUMBER = "INPUT_NUMBER_CARD";
export const TYPE_BUTTON_INPUT_TEXT = "INPUT_TEXT_CARD";
export const TYPE_BUTTON_INPUT_TOGGLE = "INPUT_TOGGLE_CARD";
export const TYPE_BUTTON_INPUT_DATE = "INPUT_DATE_CARD";
export const TYPE_BUTTON_INPUT_DATE_RANGE = "INPUT_DATE_RANGE_CARD";

export const TYPE_DOWNLOAD_DATA = "DOWNLOAD_DATA_CARD";

export const TYPE_UPLOAD_CSV = "UPLOAD_CSV_CARD";

export const BUTTON_TAGS_CARD = "BUTTON_TAGS_CARD";
export const INPUT_TOGGLE_TAGS_CARD = "INPUT_TOGGLE_TAGS_CARD";
export const INPUT_TEXT_TAGS_CARD = "INPUT_TEXT_TAGS_CARD";
export const INPUT_NUMBER_TAGS_CARD = "INPUT_NUMBER_TAGS_CARD";

export const BUTTON_CUSTOM_CARD = "BUTTON_CUSTOM_CARD";
export const INPUT_TOGGLE_CUSTOM_CARD = "INPUT_TOGGLE_CUSTOM_CARD";
export const INPUT_TEXT_CUSTOM_CARD = "INPUT_TEXT_CUSTOM_CARD";
export const INPUT_NUMBER_CUSTOM_CARD = "INPUT_NUMBER_CUSTOM_CARD";

//////////////
// QUERY REQ//
//////////////

// CHART
export const QREQ_DEVICE_ID = "device_id";
export const QREQ_DEVICE = "device";
export const QREQ_GRAPH = "graph";
export const QREQ_THREE = "three_phase";
export const QREQ_DEVICE_NO_ID = "device_no_id";
export const QREQ_TAGS = "tags";
export const QREQ_NONE = "none";
export const QREQ_DIFF = "conv_diff";
export const QREQ_CONDITION = "condition";
export const QREQ_CONDITION_BOOL = "condition_bool";

///////////
// QUERY //
///////////

// CHART
export const QUERY_LATEST = "LATEST";
export const QUERY_SAMPLE = "SAMPLE";

// SINGLE
export const QUERY_TOTAL_DEVICE = "TOTAL_DEVICE";
export const QUERY_APP_ONLINE = "APP_ONLINE";
export const QUERY_ONLINE = "ONLINE";
export const QUERY_LATITUDE = "LATITUDE";
export const QUERY_LONGITUDE = "LONGITUDE";
export const QUERY_LABEL = "LABEL";
export const QUERY_DEVICE_CATEGORY = "DEVICE_CATEGORY";
export const QUERY_DEVICE_TYPE = "DEVICE_TYPE";
export const QUERY_FIRMWARE = "FIRMWARE";
export const QUERY_SN = "SN";

// LIST MAP TITLE
export const QUERY_DEVICE_ID = "DEVICE_ID";
export const QUERY_LATEST_UPDATE = "LATEST_UPDATE";

// AGG
export const QUERY_SUM = "SUM";
export const QUERY_COUNT = "COUNT";
export const QUERY_MAX = "MAX";
export const QUERY_MIN = "MIN";
export const QUERY_USAGE = "USAGE";
export const QUERY_AVG = "AVG";
export const QUERY_LAST = "LAST";
export const QUERY_STDDEVPOP = "STDDEVPOP";
export const QUERY_STDDEVSAMP = "STDDEVSAMP";

// CONDITION
export const CONDITION_GREATER_THAN = "greater_than";
export const CONDITION_LESS_THAN = "less_than";
export const CONDITION_GREATER = "greater";
export const CONDITION_LESS = "less";
export const CONDITION_IS = "is";
export const CONDITION_IN = "in";
export const CONDITION_ALL = "all";
export const CONDITION_NOT_IN = "not_in";
export const CONDITION_LIKE = "like";

// CONDITION 
export const QUERY_CONDITION_IFELSE = "IFELSE";
export const QUERY_CONDITION_FORMAT = "FORMAT";
export const QUERY_CONDITION_MATH = "MATH";
export const QUERY_CONDITION_BOOL = "BOOL";
////////////////
// QUERY NAME //
////////////////

// CHART
export const QUERY_NAME_LATEST = "Latest";
export const QUERY_NAME_SAMPLE = "Sample";

// SINGLE
export const QUERY_NAME_TOTAL_DEVICE = "Total Device";
export const QUERY_NAME_APP_ONLINE = "Total Device Online";
export const QUERY_NAME_ONLINE = "Status Online";
export const QUERY_NAME_LATITUDE = "Latitude";
export const QUERY_NAME_LONGITUDE = "Longitude";
export const QUERY_NAME_LABEL = "Label";
export const QUERY_NAME_DEVICE_CATEGORY = "Category";
export const QUERY_NAME_DEVICE_TYPE = "Type";
export const QUERY_NAME_FIRMWARE = "Firmware";
export const QUERY_NAME_SN = "Serial Number";

// LIST MAP TITLE
export const QUERY_NAME_DEVICE_ID = "ID";
export const QUERY_NAME_LATEST_UPDATE = "Latest Update";

// AGG
export const QUERY_NAME_SUM = "Sum";
export const QUERY_NAME_COUNT = "Count";
export const QUERY_NAME_MAX = "Maximum";
export const QUERY_NAME_MIN = "Minimum";
export const QUERY_NAME_USAGE = "Usage";
export const QUERY_NAME_AVG = "Average";
export const QUERY_NAME_LAST = "Last";
export const QUERY_NAME_STDDEVPOP = "Simpangan Baku Populasi";
export const QUERY_NAME_STDDEVSAMP = "Simpangan Baku Sample";

// CONDITION 
export const QUERY_NAME_CONDITION_IFELSE = "If (condition) {true} else {false}";
export const QUERY_NAME_CONDITION_FORMAT = "Format";
export const QUERY_NAME_CONDITION_MATH = "Math";
export const QUERY_NAME_CONDITION_BOOL = "Boolean";

export function getQueryByCat(cat) {
  let query = []
  if (cat === TYPE_CARD_VALUE) {

    // Data
    query.push({ 'value': QUERY_LATEST, 'name': QUERY_NAME_LATEST, 'query_type': QREQ_DEVICE, 'selector_name': 'Data' });
    query.push({ 'value': QUERY_ONLINE, 'name': QUERY_NAME_ONLINE, 'query_type': QREQ_DEVICE_ID });
    query.push({ 'value': QUERY_TOTAL_DEVICE, 'name': QUERY_NAME_TOTAL_DEVICE, 'query_type': QREQ_TAGS });
    query.push({ 'value': QUERY_APP_ONLINE, 'name': QUERY_NAME_APP_ONLINE, 'query_type': QREQ_TAGS });

    // AGG
    query.push({ 'value': QUERY_AVG, 'name': QUERY_NAME_AVG, 'query_type': QREQ_DEVICE, 'selector_name': 'Aggregate' });
    query.push({ 'value': QUERY_COUNT, 'name': QUERY_NAME_COUNT, 'query_type': QREQ_DEVICE });
    query.push({ 'value': QUERY_MAX, 'name': QUERY_NAME_MAX, 'query_type': QREQ_DEVICE });
    query.push({ 'value': QUERY_MIN, 'name': QUERY_NAME_MIN, 'query_type': QREQ_DEVICE });
    query.push({ 'value': QUERY_SUM, 'name': QUERY_NAME_SUM, 'query_type': QREQ_DEVICE });
    query.push({ 'value': QUERY_USAGE, 'name': QUERY_NAME_USAGE, 'query_type': QREQ_DEVICE });

    // Info
    query.push({ 'value': QUERY_DEVICE_CATEGORY, 'name': QUERY_NAME_DEVICE_CATEGORY, 'query_type': QREQ_DEVICE_ID, 'selector_name': 'Device Info' });
    query.push({ 'value': QUERY_LABEL, 'name': QUERY_NAME_LABEL, 'query_type': QREQ_DEVICE_ID });
    query.push({ 'value': QUERY_DEVICE_TYPE, 'name': QUERY_NAME_DEVICE_TYPE, 'query_type': QREQ_DEVICE_ID });
    query.push({ 'value': QUERY_FIRMWARE, 'name': QUERY_NAME_FIRMWARE, 'query_type': QREQ_DEVICE_ID });
    query.push({ 'value': QUERY_LATITUDE, 'name': QUERY_NAME_LATITUDE, 'query_type': QREQ_DEVICE_ID });
    query.push({ 'value': QUERY_LONGITUDE, 'name': QUERY_NAME_LONGITUDE, 'query_type': QREQ_DEVICE_ID });
    query.push({ 'value': QUERY_SN, 'name': QUERY_NAME_SN, 'query_type': QREQ_DEVICE_ID });

  } else if (cat === TYPE_THREE_PHASE) {
    query.push({ 'value': QUERY_LATEST, 'name': QUERY_NAME_LATEST, 'query_type': QREQ_THREE });
  } else if (cat === TYPE_LIST) {
    // Data
    query.push({ 'value': QUERY_LATEST, 'name': QUERY_NAME_LATEST, 'query_type': QREQ_DEVICE_NO_ID, 'selector_name': 'Data' });
    query.push({ 'value': QUERY_ONLINE, 'name': QUERY_NAME_ONLINE, 'query_type': QREQ_NONE });

    // AGG
    query.push({ 'value': QUERY_AVG, 'name': QUERY_NAME_AVG, 'query_type': QREQ_DEVICE_NO_ID, 'selector_name': 'Aggregate' });
    query.push({ 'value': QUERY_COUNT, 'name': QUERY_NAME_COUNT, 'query_type': QREQ_DEVICE_NO_ID });
    query.push({ 'value': QUERY_MAX, 'name': QUERY_NAME_MAX, 'query_type': QREQ_DEVICE_NO_ID });
    query.push({ 'value': QUERY_MIN, 'name': QUERY_NAME_MIN, 'query_type': QREQ_DEVICE_NO_ID });
    query.push({ 'value': QUERY_SUM, 'name': QUERY_NAME_SUM, 'query_type': QREQ_DEVICE_NO_ID });
    query.push({ 'value': QUERY_USAGE, 'name': QUERY_NAME_USAGE, 'query_type': QREQ_DEVICE_NO_ID });

    // Info
    query.push({ 'value': QUERY_DEVICE_CATEGORY, 'name': QUERY_NAME_DEVICE_CATEGORY, 'query_type': QREQ_NONE, 'selector_name': 'Device Info' });
    query.push({ 'value': QUERY_FIRMWARE, 'name': QUERY_NAME_FIRMWARE, 'query_type': QREQ_NONE });
    query.push({ 'value': QUERY_DEVICE_ID, 'name': QUERY_NAME_DEVICE_ID, 'query_type': QREQ_NONE });
    query.push({ 'value': QUERY_LABEL, 'name': QUERY_NAME_LABEL, 'query_type': QREQ_NONE });
    query.push({ 'value': QUERY_LATEST_UPDATE, 'name': QUERY_NAME_LATEST_UPDATE, 'query_type': QREQ_NONE });
    query.push({ 'value': QUERY_LATITUDE, 'name': QUERY_NAME_LATITUDE, 'query_type': QREQ_NONE });
    query.push({ 'value': QUERY_LONGITUDE, 'name': QUERY_NAME_LONGITUDE, 'query_type': QREQ_NONE });
    query.push({ 'value': QUERY_SN, 'name': QUERY_NAME_SN, 'query_type': QREQ_NONE });
    query.push({ 'value': QUERY_DEVICE_TYPE, 'name': QUERY_NAME_DEVICE_TYPE, 'query_type': QREQ_NONE });

  } else if (cat === TYPE_MAP) {
    // Data
    query.push({ 'value': QUERY_LATEST, 'name': QUERY_NAME_LATEST, 'query_type': QREQ_DEVICE_NO_ID, 'selector_name': 'Data' });
    query.push({ 'value': QUERY_LATITUDE, 'name': QUERY_NAME_LATITUDE, 'query_type': QREQ_NONE });
    query.push({ 'value': QUERY_LONGITUDE, 'name': QUERY_NAME_LONGITUDE, 'query_type': QREQ_NONE });
    query.push({ 'value': QUERY_ONLINE, 'name': QUERY_NAME_ONLINE, 'query_type': QREQ_NONE });

    // AGG
    query.push({ 'value': QUERY_AVG, 'name': QUERY_NAME_AVG, 'query_type': QREQ_DEVICE_NO_ID, 'selector_name': 'Aggregate' });
    query.push({ 'value': QUERY_COUNT, 'name': QUERY_NAME_COUNT, 'query_type': QREQ_DEVICE_NO_ID });
    query.push({ 'value': QUERY_MAX, 'name': QUERY_NAME_MAX, 'query_type': QREQ_DEVICE_NO_ID });
    query.push({ 'value': QUERY_MIN, 'name': QUERY_NAME_MIN, 'query_type': QREQ_DEVICE_NO_ID });
    query.push({ 'value': QUERY_SUM, 'name': QUERY_NAME_SUM, 'query_type': QREQ_DEVICE_NO_ID });
    query.push({ 'value': QUERY_USAGE, 'name': QUERY_NAME_USAGE, 'query_type': QREQ_DEVICE_NO_ID });

    // Info
    query.push({ 'value': QUERY_DEVICE_CATEGORY, 'name': QUERY_NAME_DEVICE_CATEGORY, 'query_type': QREQ_NONE, 'selector_name': 'Device Info' });
    query.push({ 'value': QUERY_FIRMWARE, 'name': QUERY_NAME_FIRMWARE, 'query_type': QREQ_NONE });
    query.push({ 'value': QUERY_DEVICE_ID, 'name': QUERY_NAME_DEVICE_ID, 'query_type': QREQ_NONE });
    query.push({ 'value': QUERY_LABEL, 'name': QUERY_NAME_LABEL, 'query_type': QREQ_NONE });
    query.push({ 'value': QUERY_LATEST_UPDATE, 'name': QUERY_NAME_LATEST_UPDATE, 'query_type': QREQ_NONE });
    query.push({ 'value': QUERY_SN, 'name': QUERY_NAME_SN, 'query_type': QREQ_NONE });
    query.push({ 'value': QUERY_DEVICE_TYPE, 'name': QUERY_NAME_DEVICE_TYPE, 'query_type': QREQ_NONE });

  } else if (cat === TYPE_LIST_CUSTOM) {
    // Data
    query.push({ 'value': QUERY_LATEST, 'name': QUERY_NAME_LATEST, 'query_type': QREQ_DEVICE, 'selector_name': 'Data' });
    query.push({ 'value': QUERY_ONLINE, 'name': QUERY_NAME_ONLINE, 'query_type': QREQ_DEVICE_ID });

    // AGG
    query.push({ 'value': QUERY_AVG, 'name': QUERY_NAME_AVG, 'query_type': QREQ_DEVICE, 'selector_name': 'Aggregate' });
    query.push({ 'value': QUERY_COUNT, 'name': QUERY_NAME_COUNT, 'query_type': QREQ_DEVICE });
    query.push({ 'value': QUERY_MAX, 'name': QUERY_NAME_MAX, 'query_type': QREQ_DEVICE });
    query.push({ 'value': QUERY_MIN, 'name': QUERY_NAME_MIN, 'query_type': QREQ_DEVICE });
    query.push({ 'value': QUERY_SUM, 'name': QUERY_NAME_SUM, 'query_type': QREQ_DEVICE });
    query.push({ 'value': QUERY_USAGE, 'name': QUERY_NAME_USAGE, 'query_type': QREQ_DEVICE });

    // Info
    query.push({ 'value': QUERY_DEVICE_CATEGORY, 'name': QUERY_NAME_DEVICE_CATEGORY, 'query_type': QREQ_DEVICE_ID, 'selector_name': 'Device Info' });
    query.push({ 'value': QUERY_FIRMWARE, 'name': QUERY_NAME_FIRMWARE, 'query_type': QREQ_DEVICE_ID });
    query.push({ 'value': QUERY_LABEL, 'name': QUERY_NAME_LABEL, 'query_type': QREQ_DEVICE_ID });
    query.push({ 'value': QUERY_LATEST_UPDATE, 'name': QUERY_NAME_LATEST_UPDATE, 'query_type': QREQ_DEVICE_ID });
    query.push({ 'value': QUERY_LATITUDE, 'name': QUERY_NAME_LATITUDE, 'query_type': QREQ_DEVICE_ID });
    query.push({ 'value': QUERY_LONGITUDE, 'name': QUERY_NAME_LONGITUDE, 'query_type': QREQ_DEVICE_ID });
    query.push({ 'value': QUERY_SN, 'name': QUERY_NAME_SN, 'query_type': QREQ_DEVICE_ID });
    query.push({ 'value': QUERY_DEVICE_TYPE, 'name': QUERY_NAME_DEVICE_TYPE, 'query_type': QREQ_DEVICE_ID });

  } else if (cat === TYPE_TITLE) {
    // Info
    query.push({ 'value': QUERY_DEVICE_CATEGORY, 'name': QUERY_NAME_DEVICE_CATEGORY, 'query_type': QREQ_DEVICE_ID, 'selector_name': 'Device Info' });
    query.push({ 'value': QUERY_FIRMWARE, 'name': QUERY_NAME_FIRMWARE, 'query_type': QREQ_DEVICE_ID });
    query.push({ 'value': QUERY_DEVICE_ID, 'name': QUERY_NAME_DEVICE_ID, 'query_type': QREQ_DEVICE_ID });
    query.push({ 'value': QUERY_LABEL, 'name': QUERY_NAME_LABEL, 'query_type': QREQ_DEVICE_ID });
    query.push({ 'value': QUERY_SN, 'name': QUERY_NAME_SN, 'query_type': QREQ_DEVICE_ID });
    query.push({ 'value': QUERY_DEVICE_TYPE, 'name': QUERY_NAME_DEVICE_TYPE, 'query_type': QREQ_DEVICE_ID });

  } else if (isChart(cat)) {

    // (cat === TYPE_GRAPH_AREA || cat === TYPE_GRAPH_AREA_MONITORING ||
    //   cat === TYPE_GRAPH_LINE || cat === TYPE_GRAPH_LINE_MONITORING ||
    //   cat === TYPE_GRAPH_BAR || cat === TYPE_GRAPH_BAR_MONITORING ||
    //   cat === TYPE_GRAPH_PIE || cat === TYPE_GRAPH_PIE_MONITORING ||

    //   )
    query.push({ 'value': QUERY_AVG, 'name': QUERY_NAME_AVG, 'query_type': QREQ_GRAPH, 'selector_name': 'Aggregate' });
    query.push({ 'value': QUERY_COUNT, 'name': QUERY_NAME_COUNT, 'query_type': QREQ_GRAPH });
    query.push({ 'value': QUERY_LAST, 'name': QUERY_NAME_LAST, 'query_type': QREQ_GRAPH });
    query.push({ 'value': QUERY_MAX, 'name': QUERY_NAME_MAX, 'query_type': QREQ_GRAPH });
    query.push({ 'value': QUERY_MIN, 'name': QUERY_NAME_MIN, 'query_type': QREQ_GRAPH });
    query.push({ 'value': QUERY_SAMPLE, 'name': QUERY_NAME_SAMPLE, 'query_type': QREQ_GRAPH });
    query.push({ 'value': QUERY_SUM, 'name': QUERY_NAME_SUM, 'query_type': QREQ_GRAPH });
    query.push({ 'value': QUERY_USAGE, 'name': QUERY_NAME_USAGE, 'query_type': QREQ_GRAPH });
  }

  if (cat !== TYPE_THREE_PHASE) {
    // Condition
    query.push({ 'value': QUERY_CONDITION_BOOL, 'name': QUERY_NAME_CONDITION_BOOL, 'query_type': QREQ_CONDITION, 'selector_name': 'Condition' });
    query.push({ 'value': QUERY_CONDITION_FORMAT, 'name': QUERY_NAME_CONDITION_FORMAT, 'query_type': QREQ_CONDITION });
    query.push({ 'value': QUERY_CONDITION_IFELSE, 'name': QUERY_NAME_CONDITION_IFELSE, 'query_type': QREQ_CONDITION_BOOL });
    query.push({ 'value': QUERY_CONDITION_MATH, 'name': QUERY_NAME_CONDITION_MATH, 'query_type': QREQ_CONDITION });
  }
  return query;
}


export function getControlReverse(type, isAuto) {
  if (isAuto) {
    if (type === BUTTON_CUSTOM_CARD) {
      return BUTTON_TAGS_CARD;
    } else if (type === INPUT_TOGGLE_CUSTOM_CARD) {
      return INPUT_TOGGLE_TAGS_CARD;
    } else if (type === INPUT_TEXT_CUSTOM_CARD) {
      return INPUT_TEXT_TAGS_CARD;
    } else if (type === INPUT_NUMBER_CUSTOM_CARD) {
      return INPUT_NUMBER_TAGS_CARD;
    } else {
      return type
    }
  } else {
    if (type === BUTTON_TAGS_CARD) {
      return BUTTON_CUSTOM_CARD;
    } else if (type === INPUT_TOGGLE_TAGS_CARD) {
      return INPUT_TOGGLE_CUSTOM_CARD;
    } else if (type === INPUT_TEXT_TAGS_CARD) {
      return INPUT_TEXT_CUSTOM_CARD;
    } else if (type === INPUT_NUMBER_TAGS_CARD) {
      return INPUT_NUMBER_CUSTOM_CARD;
    } else {
      return type
    }
  }
}

// export const COLOR_PALETTE = [
//   "#1f77b4",
//   "#ff7f0e",
//   "#2ca02c",
//   "#d62728",
//   "#9467bd",
//   "#8c564b",
//   "#e377c2",
//   "#7f7f7f",
//   "#bcbd22",
//   "#17becf"
// ];

export const COLOR_PALETTE = [
  "#4263EB",
  "#D84910",
  "#F784AD",
  "#F1D678",
  "#F35F5F",
  "#1EC086",
  "#56CCF2"
];


export const FILTER_REALTIME = "REALTIME";
export const FILTER_PERIOD = "PERIODIC";
export const FILTER_CUSTOM = "CUSTOM";

// export const COLOR_PALETTE = ["#003f5c", "#2f4b7c", "#665191", "#a05195", "#d45087", "#f95d6a", "#ff7c43", "#ffa600", "#bcbd22", "#17becf"];
export const REALTIME = "REALTIME";
export const TODAY = "TODAY";
export const THIS_WEEK = "THIS_WEEK";
export const THIS_MONTH = "THIS_MONTH";
export const THIS_YEAR = "THIS_YEAR";
export const LAST_5 = "LAST_5";
export const LAST_15 = "LAST_15";
export const LAST_30 = "LAST_30";
export const LAST_HOUR = "LAST_HOUR";
export const LAST_DAY = "LAST_DAY";
export const LAST_WEEK = "LAST_WEEK";
export const LAST_MONTH = "LAST_MONTH";
export const LAST_YEAR = "LAST_YEAR";
export const GET_DAY = "GET_DAY";
export const GET_WEEK = "GET_WEEK";
export const GET_MONTH = "GET_MONTH";
export const GET_YEAR = "GET_YEAR";

export const BEGINNING_OF_DAY = "BEGINNING_OF_DAY";
export const END_OF_DAY = "END_OF_DAY";
export const BEGINNING_OF_WEEK = "BEGINNING_OF_WEEK";
export const END_OF_WEEK = "END_OF_WEEK";
export const BEGINNING_OF_MONTH = "BEGINNING_OF_MONTH";
export const END_OF_MONTH = "END_OF_MONTH";
export const BEGINNING_OF_YEAR = "BEGINNING_OF_YEAR";
export const END_OF_YEAR = "END_OF_YEAR";
export const NOW = "NOW";


export const DATE_MINUTE_SECOND_SIMPLE = "HH:mm:ss";
export const DATE_MINUTE_SIMPLE = "HH:mm";
export const DATE_MINUTE_SECOND = "HH:mm:ss, DD MMM 'YY";
export const DATE_MINUTE = "HH:mm, DD MMM 'YY";
export const DATE_HOUR = "Jam HH, DD MMM 'YY";
export const DATE_DAY_SIMPLE = "DD MMM";
export const DATE_DAY = "DD MMM 'YY";
export const DATE_MONTH_SIMPLE = "MMMM";
export const DATE_MONTH = "MMMM YYYY";
export const DATE_YEAR = "YYYY";


export const TASK_STAT_NEW = 0;
export const TASK_STAT_IN_PROGRESS = 1;
export const TASK_STAT_PENDING = 8;
export const TASK_STAT_SOLVED = 10;
export const TASK_STAT_CLOSED = 20;
export const TASK_STAT_RULE_NEW = 100;
export const TASK_STAT_RULE_SOLVED = 110;

const CONFIG_CONF = "config";
const CONFIG_DATA = "data";
const CONFIG_CMD = "command";

export function isDataConf(type) {
  return type === CONFIG_DATA;
}

export function isConfigConf(type) {
  return type === CONFIG_CONF;
}

export function isCommandConf(type) {
  return type === CONFIG_CMD;
}

export function isDashboardCat(cat) {
  return (
    cat === TYPE_CARD_VALUE ||
    cat === TYPE_MAP ||
    cat === TYPE_GRAPH_LINE_SMART ||
    cat === TYPE_GRAPH_BAR_MONITORING ||
    cat === TYPE_GRAPH_LINE_MONITORING ||
    cat === TYPE_GRAPH_PIE_MONITORING ||
    cat === TYPE_GRAPH_AREA_MONITORING ||
    cat === TYPE_GRAPH_BAR ||
    cat === TYPE_GRAPH_LINE ||
    cat === TYPE_GRAPH_TEXT ||
    cat === TYPE_GRAPH_PIE ||
    cat === TYPE_GRAPH_AREA ||
    cat === TYPE_BUTTON_SIMPLE ||
    cat === BUTTON_TAGS_CARD ||
    cat === INPUT_TOGGLE_TAGS_CARD ||
    cat === INPUT_TEXT_TAGS_CARD ||
    cat === INPUT_NUMBER_TAGS_CARD ||
    cat === TYPE_BUTTON_INPUT_NUMBER ||
    cat === TYPE_BUTTON_INPUT_TEXT ||
    cat === TYPE_BUTTON_INPUT_TOGGLE ||
    cat === TYPE_BUTTON_INPUT_DATE ||
    cat === TYPE_BUTTON_INPUT_DATE_RANGE ||
    cat === BUTTON_CUSTOM_CARD ||
    cat === INPUT_TOGGLE_CUSTOM_CARD ||
    cat === INPUT_TEXT_CUSTOM_CARD ||
    cat === INPUT_NUMBER_CUSTOM_CARD
  );
}

export function isCommand(cat) {
  return (
    cat === TYPE_BUTTON_SIMPLE ||
    cat === TYPE_UPLOAD_CSV ||
    cat === BUTTON_TAGS_CARD ||
    cat === INPUT_TOGGLE_TAGS_CARD ||
    cat === INPUT_TEXT_TAGS_CARD ||
    cat === INPUT_NUMBER_TAGS_CARD ||
    cat === TYPE_BUTTON_INPUT_NUMBER ||
    cat === TYPE_BUTTON_INPUT_TEXT ||
    cat === TYPE_BUTTON_INPUT_TOGGLE ||
    cat === TYPE_BUTTON_INPUT_DATE ||
    cat === TYPE_BUTTON_INPUT_DATE_RANGE ||
    cat === BUTTON_CUSTOM_CARD ||
    cat === INPUT_TOGGLE_CUSTOM_CARD ||
    cat === INPUT_TEXT_CUSTOM_CARD ||
    cat === INPUT_NUMBER_CUSTOM_CARD
  );
}

export function isChart(cat) {
  return (
    cat === TYPE_GRAPH_LINE_SMART ||
    cat === TYPE_GRAPH_BAR_MONITORING ||
    cat === TYPE_GRAPH_LINE_MONITORING ||
    cat === TYPE_GRAPH_TEXT ||
    cat === TYPE_GRAPH_PIE ||
    cat === TYPE_GRAPH_PIE_MONITORING ||
    cat === TYPE_GRAPH_AREA_MONITORING
  );
}

export function isMonitoring(cat) {
  return (
    cat === TYPE_GRAPH_LINE_SMART ||
    cat === TYPE_GRAPH_BAR_MONITORING ||
    cat === TYPE_GRAPH_LINE_MONITORING ||
    cat === TYPE_GRAPH_AREA_MONITORING
  );
}

export let FILTERS_GRAPH = {
  'Last 15 minutes': { value: 'l_15_m', name: 'Last 15 minutes', range: 'LAST_MINUTE', range_param: 15, period: 'second', interval: 10 },
  'Last 30 minutes': { value: 'l_30_m', name: 'Last 30 minutes', range: 'LAST_MINUTE', range_param: 30, period: 'second', interval: 20 },
  'Last 1 hour': { value: 'l_1_h', name: 'Last 1 hour', range: 'LAST_HOUR', range_param: 1, period: 'minute', interval: 1 },
  'Last 3 hours': { value: 'l_3_h', name: 'Last 3 hours', range: 'LAST_HOUR', range_param: 3, period: 'minute', interval: 5 },
  'Last 6 hours': { value: 'l_6_h', name: 'Last 6 hours', range: 'LAST_HOUR', range_param: 6, period: 'minute', interval: 15 },
  'Last 12 hours': { value: 'l_12_h', name: 'Last 12 hours', range: 'LAST_HOUR', range_param: 12, period: 'minute', interval: 20 },
  'Last 24 hours': { value: 'l_24_h', name: 'Last 24 hours', range: 'LAST_DAY', range_param: 1, period: 'minute', interval: 30 },
  'Last 7 days': { value: 'l_7_d', name: 'Last 7 days', range: 'LAST_WEEK', range_param: 1, period: 'hour', interval: 6 },
  'Last 30 days': { value: 'l_30_d', name: 'Last 30 days', range: 'LAST_MONTH', range_param: 1, period: 'day', interval: 1 },
  'Last 1 year': { value: 'l_1_y', name: 'Last 1 year', range: 'LAST_YEAR', range_param: 1, period: 'month', interval: 1 },
  'Today': { value: 't_1_d', name: 'Today', range: 'TODAY', range_param: 1, period: 'minute', interval: 30 },
  'This Week': { value: 't_1_w', name: 'This Week', range: 'THIS_WEEK', range_param: 1, period: 'hour', interval: 6 },
  'This Month': { value: 't_1_m', name: 'This Month', range: 'THIS_MONTH', range_param: 1, period: 'day', interval: 1 },
  'This Year': { value: 't_1_y', name: 'This Year', range: 'THIS_YEAR', range_param: 1, period: 'month', interval: 1 },
  'Last 50 data': { value: 'l_50_dt', name: 'Last 50 data', range: 'REALTIME', ndata: 50 },
  'Last 100 Data': { value: 'l_100_dt', name: 'Last 100 Data', range: 'REALTIME', ndata: 100 },
};

export function buildFilter(filters) {
  let finalFilter = {};

  if (filters.length === 0) {
    finalFilter.default = {
      name: 'Last 30 minutes',
      range: 'LAST_MINUTE',
      range_param: 30,
      period: 'second',
      interval: 20
    }
    finalFilter.lasthour = {
      name: 'Last 1 hour',
      range: 'LAST_HOUR',
      range_param: 1,
      period: 'minute',
      interval: 1
    }
  } else {
    for (let i = 0; i < filters.length; i++) {
      let filter = filters[i];
      if (i === 0) {
        finalFilter.default = {
          name: FILTERS_GRAPH[filter].name,
          range: FILTERS_GRAPH[filter].range,
          range_param: FILTERS_GRAPH[filter].range_param,
          period: FILTERS_GRAPH[filter].period,
          interval: FILTERS_GRAPH[filter].interval
        }
      } else {
        if (filter !== 'Last 50 data' && filter !== 'Last 100 data') {
          finalFilter[FILTERS_GRAPH[filter].value] = {
            name: FILTERS_GRAPH[filter].name,
            range: FILTERS_GRAPH[filter].range,
            range_param: FILTERS_GRAPH[filter].range_param,
            period: FILTERS_GRAPH[filter].period,
            interval: FILTERS_GRAPH[filter].interval
          }
        } else {
          finalFilter[FILTERS_GRAPH[filter].value] = {
            name: FILTERS_GRAPH[filter].name,
            range: FILTERS_GRAPH[filter].range,
            ndata: FILTERS_GRAPH[filter].ndata
          }
        }
      }
    }
  }
  return finalFilter
}

export function isDownloadable(cat) {
  return (
    cat === TYPE_GRAPH_LINE_SMART ||
    cat === TYPE_GRAPH_BAR_MONITORING ||
    cat === TYPE_GRAPH_LINE_MONITORING ||
    cat === TYPE_GRAPH_PIE_MONITORING ||
    cat === TYPE_GRAPH_AREA_MONITORING ||
    cat === TYPE_GRAPH_BAR ||
    cat === TYPE_GRAPH_LINE ||
    cat === TYPE_GRAPH_TEXT ||
    cat === TYPE_GRAPH_PIE ||
    cat === TYPE_GRAPH_AREA ||
    cat === TYPE_LIST_TRANSACTION ||
    cat === TYPE_LIST_PAYMENT ||
    cat === TYPE_DOWNLOAD_DATA
  );
}

export function isCommandCard(cat) {
  return (
    cat === TYPE_UPLOAD_CSV ||
    cat === BUTTON_TAGS_CARD ||
    cat === INPUT_TOGGLE_TAGS_CARD ||
    cat === INPUT_TEXT_TAGS_CARD ||
    cat === INPUT_NUMBER_TAGS_CARD ||
    cat === BUTTON_CUSTOM_CARD ||
    cat === INPUT_TOGGLE_CUSTOM_CARD ||
    cat === INPUT_TEXT_CUSTOM_CARD ||
    cat === INPUT_NUMBER_CUSTOM_CARD
  );
}

export function isTagsAvailable(cat) {
  return (
    isNormalCommand(cat) ||
    cat === TYPE_DROPDOWN_SELECTOR ||
    cat === TYPE_MAP ||
    cat === TYPE_LIST ||
    cat === TYPE_LIST_TRANSACTION ||
    cat === TYPE_LIST_PAYMENT
  );
}

export function isNormalCommand(cat) {
  return (
    cat === BUTTON_TAGS_CARD ||
    cat === INPUT_TOGGLE_TAGS_CARD ||
    cat === INPUT_TEXT_TAGS_CARD ||
    cat === INPUT_NUMBER_TAGS_CARD
  );
}

export function isCustomCommand(cat) {
  return (
    cat === BUTTON_CUSTOM_CARD ||
    cat === INPUT_TOGGLE_CUSTOM_CARD ||
    cat === INPUT_TEXT_CUSTOM_CARD ||
    cat === INPUT_NUMBER_CUSTOM_CARD
  );
}

export function isCustomCategory(cat) {
  return (
    cat === TYPE_LIST_CUSTOM ||
    cat === BUTTON_CUSTOM_CARD ||
    cat === INPUT_TOGGLE_CUSTOM_CARD ||
    cat === INPUT_TEXT_CUSTOM_CARD ||
    cat === INPUT_NUMBER_CUSTOM_CARD
  );
}

export function hasNoBackground(cat) {
  return cat === TYPE_TITLE;
}

export function isInputCommandCard(cat) {
  return (
    cat === INPUT_TOGGLE_TAGS_CARD ||
    cat === INPUT_TEXT_TAGS_CARD ||
    cat === INPUT_NUMBER_TAGS_CARD ||
    cat === INPUT_TOGGLE_CUSTOM_CARD ||
    cat === INPUT_TEXT_CUSTOM_CARD ||
    cat === INPUT_NUMBER_CUSTOM_CARD
  );
}

export const DEVICE_CAT_DUMMY = 0;
export const DEVICE_CAT_KAA = 1;
export const DEVICE_CAT_MQTT = 2;
export const DEVICE_CAT_TASMOTA = 21;
export const DEVICE_CAT_LORA = 11;
export const DEVICE_CAT_ZLAN = 101;
export const DEVICE_CAT_UI = 102;
export const DEVICE_CAT_BIVOCOM = 103;
export const DEVICE_CAT_FRIENDCOM = 104;
export const DEVICE_CAT_IOTERA = 10000;
export const DEVICE_CAT_EMMA = 2000;
export const DEVICE_CAT_IMOU_CAMERA = 110001;

export const TAG_CAT_SINGLE_SELECTION = 1;
export const TAG_CAT_SINGLE_VALUE = 2;
export const TAG_CAT_CHECKBOX = 3;
export const TAG_CAT_MULTI_VALUE = 4;
